import React, { useState, useEffect } from "react";
import Grid                           from '@mui/material/Grid';
import BlogCard                       from '../atoms/blogCard';

import { articleSearch }              from '../../../apis/article';

const initialState = {
    data: false,
};

export default function Content () {
	const [{ data }, setState] = useState (initialState);

	useEffect(() => {
		const getData = async () => {
			try {
				const resp = await articleSearch ();
				setState (prevState => ({ ...prevState, 'data': resp }));

			} catch (err) {
				setState (prevState => ({ ...prevState, 'data': null }));
				console.error (err);
			}
		}
		getData ();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (data === null)
		return (
			<p>Some error in the server please try later </p>
		);

	return (
		<Grid spacing={1} container style={{marginBottom: '20px'}}>
			<Grid item xs={false} md={2} style={{backgroundColor : ''}}></Grid>
			<Grid container item xs={12} md={8}>
				{
					data && data.length && data.map ((d, index) => (
						<Grid item xs={12} md={6} style={{backgroundColor: ''}} key={index}>
							<BlogCard data={d} />
						</Grid>
					))
				}
			</Grid>
			<Grid item xs={false} md={2} style={{backgroundColor : ''}}></Grid>
		</Grid>
	);
}
